import React from 'react';
import { ToolbarButton } from '@mui/x-data-grid-pro';
import Tooltip from '@mui/material/Tooltip';
import { ToggleOff, ToggleOn } from '@mui/icons-material';

const ToggleButton = ({ onClick, label, value }) => (
  <Tooltip title={label}>
    <ToolbarButton onClick={onClick}>
      {value ? <ToggleOn fontSize="small" /> : <ToggleOff fontSize="small" />}
    </ToolbarButton>
  </Tooltip>
);

export default ToggleButton;